import { render, staticRenderFns } from "./PicturePicker.vue?vue&type=template&id=04f95065"
import script from "./PicturePicker.vue?vue&type=script&lang=js"
export * from "./PicturePicker.vue?vue&type=script&lang=js"
import style0 from "./PicturePicker.vue?vue&type=style&index=0&id=04f95065&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports